export default "__VITE_ASSET__DgxWdMrz__"